import CHECKPOINT_LIST from '../../graphql/checkpoint/list.graphql'
import CHECKPOINT_CREATE from '../../graphql/checkpoint/create.graphql'
import CHECKPOINT_UPDATE from '../../graphql/checkpoint/update.graphql'
import CHECKPOINT_DELETE from '../../graphql/checkpoint/delete.graphql'

import {processMutation, processQuery, genericMutations} from '../utils'

export default {
    namespaced: true,
    state: {
        list: [],
        detail: null,
    },

    mutations: {
        ...genericMutations('list', 'detail'),
    },

    actions: {
        async list({commit}) {
            return await processQuery(this, CHECKPOINT_LIST, 'checkpoint.list', {}, 'checkpoint/setList')
        },

        async create({commit}, data) {
            data.ticketsetIds = data.ticketsetIds.map(t => parseInt(t))

            if (data.user) {
                data.user = parseInt(data.user)
            }
            return await processMutation(this, CHECKPOINT_CREATE, 'checkpoint.create', data)
        },

        async update({commit}, data) {
            data.ticketsetIds = data.ticketsetIds.map(t => parseInt(t))
            data.id = parseInt(data.id)

            if (data.user) {
                data = {...data, user: parseInt(data.user.id)}
            }
            return await processMutation(this, CHECKPOINT_UPDATE, 'checkpoint.update', data)
        },

        async delete({commit}, id) {
            return await processMutation(this, CHECKPOINT_DELETE, 'checkpoint.delete', {id: id})
        },
    }
}
